import { Button, Card } from "../../../shared";
import { CardHeader } from "../../../shared/Card/CardHeader";
import { formatLabel, isManualBillingCollection } from "./billing.utils";

/**
 * Self-serve plan picker shown when checkout is available.
 */
export const BillingPlanOptions = ({
  collectionMethod = "manual_invoice",
  selfServeOffers = [],
  currentPlanKey = null,
  canStartCheckout = false,
  canManagePortal = false,
  checkoutLoading = false,
  portalLoading = false,
  onStartCheckout,
  onManageBilling,
}) => {
  if (isManualBillingCollection(collectionMethod)) {
    return null;
  }

  if (!canStartCheckout && selfServeOffers.length === 0) {
    return null;
  }

  return (
    <Card
      header={<CardHeader title="Available plans" />}
      content={
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            Pick a plan to subscribe in-app. You can change plans or cancel later from billing
            settings.
          </p>
          <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
            {selfServeOffers.map((catalogOffer) => {
              const isCurrentPlan = currentPlanKey === catalogOffer.key;

              return (
                <div
                  key={catalogOffer.key}
                  className="rounded-lg border border-gray-200 p-4"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h4 className="font-semibold text-gray-900">{catalogOffer.name}</h4>
                      <p className="mt-1 text-sm text-gray-600">{catalogOffer.description}</p>
                      <p className="mt-2 text-xs text-gray-500">
                        Includes {formatLabel(catalogOffer.planTier || "tier1")} features
                      </p>
                    </div>
                    {isCurrentPlan ? (
                      <span className="rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-800">
                        Current
                      </span>
                    ) : null}
                  </div>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {canStartCheckout ? (
                      <Button
                        title={
                          checkoutLoading && isCurrentPlan
                            ? "Opening..."
                            : isCurrentPlan
                            ? "Current plan"
                            : `Choose ${catalogOffer.name}`
                        }
                        size="sm"
                        onClick={() => onStartCheckout(catalogOffer.key)}
                        disabled={checkoutLoading || isCurrentPlan}
                      />
                    ) : null}
                    {canManagePortal && isCurrentPlan ? (
                      <Button
                        title={portalLoading ? "Opening..." : "Manage subscription"}
                        size="sm"
                        type="light"
                        onClick={onManageBilling}
                        disabled={portalLoading}
                      />
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
          {selfServeOffers.length === 0 ? (
            <p className="text-sm text-gray-600">
              No self-serve plans are configured for this environment yet.
            </p>
          ) : null}
        </div>
      }
    />
  );
};
